


















import EmptyValue from './EmptyValue.vue';

export default {
  name: 'DatePresenter',
  inject: {
    components: {
      default: {
        EmptyValue,
      },
    },
  },
};
